import React from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import { MAP } from 'react-google-maps/lib/constants';

/*
 * From https://gist.github.com/jgimbel/6a36d60e28aaf453d0093ddc47f36533#gistcomment-2766146
 */

export default class CustomControl extends React.Component {
  static propTypes = {
    controlPosition: PropTypes.number.isRequired,
    children: PropTypes.node,
  };

  static contextTypes = { [MAP]: PropTypes.object };

  constructor(props, context) {
    super(props);

    this.map = context[MAP];
    this.controlDiv = document.createElement('div');
    this.divIndex = this.map.controls[this.props.controlPosition].length;
    this.map.controls[props.controlPosition].push(this.controlDiv);
  }

  componentWillUnmount() {
    this.map.controls[this.props.controlPosition].removeAt(this.divIndex);
  }

  render() {
    return createPortal(this.props.children, this.controlDiv);
  }
}



// WEBPACK FOOTER //
// ./src/common/components/MapComponent/CustomControl.js